import React from "react";

const Notifications = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="current"
      style={{ display: "block" }}
    >
      <path d="M12 24c1.326 0 2.402-1.076 2.402-2.402h-4.804C9.598 22.924 10.674 24 12 24zM18.707 16.293C18.316 15.902 18 15.385 18 14.828V10c0-3.309-2.239-6.091-5.25-6.837V2.5c0-.828-.671-1.5-1.5-1.5S9.75 1.672 9.75 2.5v.663C6.739 3.909 4.5 6.691 4.5 10v4.828c0 .557-.316 1.074-.707 1.465-.391.391-.793.844-.793 1.379 0 .828.672 1.5 1.5 1.5h13.5c.828 0 1.5-.672 1.5-1.5 0-.535-.402-.988-.793-1.379z" />
    </svg>
  );
};

export default Notifications;
